import { useState, useEffect } from "react";
import axios from "axios";
import { Bot, User } from "lucide-react";
import { S, MANROPE, API, auDateTime } from "./lib";

const when = (iso) => auDateTime(iso);

const TOOL_WORDS = {
  write_channel_copy: "wrote the channel copy",
  write_creative_brief: "wrote the creative brief",
  create_draft_post: "drafted this post",
  create_post: "added this post",
  submit_for_approval: "submitted it for approval",
  record_live_urls: "recorded the live links",
  progress_dependency: "chased a dependency",
  add_dependency: "added a dependency",
  update_dependency: "moved a dependency on",
  clear_dependency: "cleared a dependency",
  remove_dependency: "removed a dependency",
  set_readiness: "ticked off readiness",
  edit_post: "edited the post",
  approve: "approved it",
  override_house_rules: "approved it over a house rule",
  unapprove: "removed the approval",
  send_back: "sent it back",
  send_back_post: "sent it back",
  publish: "confirmed it published",
};

/* "Anthony Roche, through Claude" where it used to say "Claude". Work done by
   hand reads exactly as it did. */
export const actorLine = (h) => {
  if (h.actor_kind === "claude_delegated") return `${h.actor || "Someone"}, through Claude`;
  if (h.actor_kind === "claude") return h.actor || "Claude (machine)";
  return h.actor || "Someone";
};

/* Which changes came from Claude and why, next to the ones made by hand. */
export default function SocialHistory({ postUid }) {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    axios.get(`${API}/posts/${postUid}/history`)
      .then((r) => setRows(r.data.history || [])).catch(() => setRows([]));
  }, [postUid]);

  return (
    <div className="rounded-[10px] p-3.5 space-y-2.5" data-testid="social-history"
      style={{ background: S.card, border: `1px solid ${S.border}` }}>
      <div style={{ ...MANROPE, fontSize: 13.5, fontWeight: 700, color: S.ink }}>History</div>
      {rows === null ? (
        <p className="text-[12px]" style={{ color: S.ink3 }}>Loading…</p>
      ) : rows.length === 0 ? (
        <p className="text-[12px]" style={{ color: S.ink3 }}>Nothing recorded against this post yet.</p>
      ) : rows.map((h) => (
        <div key={h.id} className="flex items-start gap-2 text-[12px]" data-testid={`social-history-${h.id}`}>
          {(h.actor_kind || "").startsWith("claude")
            ? <Bot className="w-3.5 h-3.5 shrink-0 mt-0.5" style={{ color: S.accentInk }} />
            : <User className="w-3.5 h-3.5 shrink-0 mt-0.5" style={{ color: S.ink3 }} />}
          <div>
            <span style={{ color: S.ink }}>
              <b>{actorLine(h)}</b> {TOOL_WORDS[h.tool] || h.tool}
            </span>
            <span className="ml-1" style={{ color: S.ink3 }}>· {when(h.at)}</span>
            {h.reason && <span className="block" style={{ color: S.ink2 }}>“{h.reason}”</span>}
          </div>
        </div>
      ))}
    </div>
  );
}
